import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import Concept from "@/components/site/Concept";

export default function About() {
  return (
    <div className="bg-[#faf8f5] min-h-screen">
      <Nav solid />
      <div className="pt-16 md:pt-20">
        <Concept />
      </div>
      <Footer />
    </div>
  );
}
